import './Splash.css';
import logo from '../../../assets/img/MSB-logo.png';

const Splash = () => {
  return (
    <div className="splash-screen">
      <img src={logo} alt="Magic Spice Bites Logo" className="splash-logo" />
    </div>
  );
};

export default Splash;
